import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
  HttpClient,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';
@Injectable()
export class AuthService {
  hostUrl: any = environment.API_BASE_URL;
  portalHostUrl = environment.PORTAL_BASE_URL;
  public token: string;

  urlToSaveUser: any = this.hostUrl + 'api/createCustomer';
  urlToLogin: any = this.hostUrl + 'api/custSignIn';
  urlToRegisterPhone: any = this.hostUrl + 'api/phoneRegister';
  urlToVerifyPhone: any = this.hostUrl + 'api/phoneVerify';
  urlToSaveProfile: any = this.hostUrl + 'api/updateCustomer';
  urlToFetchBundles: any = this.hostUrl + 'api/getBundles';
  urlToUpdateBundlePicked: any = this.hostUrl + 'api/bundlesPicked';
  urlToResetPassword: any = this.hostUrl + 'password/email';
  urlToEstimateBills: any = this.hostUrl + 'api/savings-estimate';
  urlToSaveAccounts: any = this.hostUrl + 'api/updateAccount';
  urlToChangePassowrd: any = this.hostUrl + 'password/reset';
  urlToGetProviders: any = this.hostUrl + 'api/getProviders';
  urlToGetAccounts: any = this.hostUrl + 'api/getAccountById';
  urlToLoginWithFb: any = this.hostUrl + 'api/fbLogin';
  urlToStoreCard: any = this.hostUrl + 'api/saveCardDetails';
  urlToArchiveCustomer: any = this.hostUrl + 'api/archiveCustomer';
  urlToUnArchiveCustomer: any = this.hostUrl + 'api/unArchiveCustomer';
  urlToGetEmployee: any = this.portalHostUrl + 'employees';
  constructor(private _http: HttpClient, private _appSpinnerservice: AppLoadingService) {}

  // with interceptor
  login(email: string, password: string): Observable<any> {
    return this._http
      .post(this.urlToLogin, { email: email, password: password })
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }

  loginWithFB(email: string, token: string): Observable<any> {
    return this._http
      .post(this.urlToLoginWithFb, { email: email, token: token })
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }

  logout(): void {}
  loginWithfacebook() {}
  forgotpassword(email: string): Observable<any> {
    return this._http
      .post(this.urlToResetPassword, { email: email })
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }

  // TODO : Move to UserOnBoardingService

  signup(email: string, phone: string, fullname: string): Observable<any> {
    return this._http
      .post(this.urlToSaveUser, {
        email: email,
        phone: phone,
        fullname: fullname,
        isCreatedViaPortal: true
      })
      .map((res: Response) => res);
  }

  registerPhone(answer: any, phone: string, userId: any): Observable<any> {
    return this._http
      .post(this.urlToRegisterPhone, {
        selectedAnswer: answer,
        phoneNumber: phone,
        customerId: userId
      })
      .map((res: Response) => res);
  }

  verifyPhone(phoneNumber: string, customerId: any): Observable<any> {
    return this._http
      .post(this.urlToVerifyPhone, { customerId: customerId, phoneNumber: phoneNumber })
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }

  saveProfile(user): Observable<any> {
    return this._http
      .post(this.urlToSaveProfile, user)
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }
  saveCard(data: any): Observable<any> {
    return this._http
      .post(this.urlToStoreCard, data)
      .map((res: Response) => res)
      .catch(res => Observable.throw(res));
  }
  fetchBundles(): Observable<any> {
    return this._http.get(this.urlToFetchBundles).map((res: Response) => res);
  }
  fetchProviders(): Observable<any> {
    return this._http.get(this.urlToGetProviders).map((res: Response) => res);
  }
  fetchAccounts(user_id: string): Observable<any> {
    return this._http.get(this.urlToGetAccounts + '/' + user_id).map((res: Response) => res);
  }
  saveBundlesSelected(bundleSelection, userId: any): Observable<any> {
    return this._http
      .post(this.urlToUpdateBundlePicked, { _id: userId, bundlesPicked: bundleSelection })
      .map((res: Response) => res);
  }
  estimateBills() {
    return this._http.get(this.urlToEstimateBills).map((res: Response) => res);
  }
  saveAccountsCreds(data) {
    return this._http.post(this.urlToSaveAccounts, data).map((res: Response) => res);
  }
  changePassword(email: string, newPassword: string, confirmPassword: string, token: string) {
    return this._http
      .post(this.urlToChangePassowrd, {
        email: email,
        password: newPassword,
        password_confirmation: confirmPassword,
        token: token
      })
      .map((res: Response) => res);
  }
  archiveCustomer(custId: string, archive_reason_id: string, employee_details: any) {
    return this._http
      .post(this.urlToArchiveCustomer, {
        custId: custId,
        archive_reason_id: archive_reason_id,
        data: { employee_details }
      })
      .map((res: Response) => res);
  }
  unArchiveCustomer(custId: string, unArchive_reason_id: string, employee_details: any) {
    return this._http
      .post(this.urlToUnArchiveCustomer, {
        custId: custId,
        unArchived_reason_id: unArchive_reason_id,
        data: { employee_details }
      })
      .map((res: Response) => res);
  }

  getLoggedInUser(data: any) {
    let url = this.urlToGetEmployee + `/${data._id}`;
    return this._http.get(url).map((res: Response) => res);
  }
  // TOTO : End Move to UserOnBoardingService
}



// WEBPACK FOOTER //
// ./src/app/_services/main/auth.service.ts